module.exports = __webpack_public_path__ + "img/banner.c3c8f6f.webp";